module.exports = __webpack_public_path__ + "img/payments.d12300b5.jpg";